<template>
  <transition name="slide-fade">
    <div
      v-if="toast.visible"
      class="fixed top-6 w-80"
      style="z-index: 1999; left: calc(50% - 10rem);"
      @mouseenter="handleMouseenter"
      @mouseleave="handleHideToast">
      <my-alert shadow :type="toast.type || 'success'" closable @close="hide_toast">{{ toast.message }}</my-alert>
    </div>
  </transition>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      timeout: 0
    }
  },
  computed: {
    ...mapGetters(['toast'])
  },
  watch: {
    'toast.visible': function (val) {
      if (val) {
        this.handleHideToast()
      }
    }
  },
  methods: {
    ...mapActions(['hide_toast']),
    handleMouseenter () {
      window.clearTimeout(this.timeout)
    },
    handleHideToast () {
      this.timeout = window.setTimeout(() => {
        this.hide_toast()
      }, 2000)
    }
  }
}
</script>
<style scoped>
.slide-fade-enter-active {
  transition: all 0.2s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
